const CSRF_COOKIE = 'bm_csrf';
const CSRF_HEADER = 'X-CSRF-Token';
const MUTATING = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

export function readCsrfToken(): string | undefined {
    const match = document.cookie.split('; ').find((c) => c.startsWith(`${CSRF_COOKIE}=`));
    if (!match) return undefined;
    const value = match.slice(CSRF_COOKIE.length + 1);
    return value || undefined;
}

export function applyCsrfHeader(method: string | undefined, headers: Headers): Headers {
    if (!method || !MUTATING.has(method.toUpperCase())) return headers;
    const token = readCsrfToken();
    if (token) headers.set(CSRF_HEADER, token);
    return headers;
}

export async function isCsrfMismatch(response: Response): Promise<boolean> {
    if (response.status !== 403) return false;
    try {
        return (await response.clone().text()).includes('csrf_token_mismatch');
    } catch {
        return false;
    }
}
